'use strict';

var TemplatePreviewController = function TemplatePreviewController($scope) {
  $scope.editSelectedStrategy = function () {
    $scope.closePanelHandler();
    $scope.$emit('strategy:createStrategy', $scope.strategyTemplate.id);
  };
};
TemplatePreviewController.$inject = ['$scope'];
module.exports = TemplatePreviewController;